export const partsApi = (client) => ({
    list: (params) => client.get('/api/v1/parts', { params }).then((r) => r.data),
    get: (id) => client.get(`/api/v1/parts/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/parts', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/parts/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/parts/${id}`).then((r) => r.data),
    /// Bulk-import parts from a parsed CSV. Runs inside a single DB
    /// transaction — if any row fails validation or a FK lookup fails,
    /// the whole import rolls back and a 422 with row-scoped errors is
    /// returned so the UI can show which rows to fix.
    bulkCreate: (rows) => client.post('/api/v1/parts/bulk', { rows }).then((r) => r.data),
    /// Soft-delete up to 200 parts in one call. Returns the per-id outcome
    /// so the caller can show "deleted X, skipped Y" with reasons.
    bulkRemove: (ids) => client.post('/api/v1/parts/bulk-delete', { ids }).then((r) => r.data),
    getAuditLog: (id) => client.get(`/api/v1/parts/${id}/audit`).then((r) => r.data),
    /// Every work order this part has been used on, via work_order_parts.
    listWorkOrders: (id) => client.get(`/api/v1/parts/${id}/work-orders`).then((r) => r.data),
    sendReorderEmail: (id, body) => client.post(`/api/v1/parts/${id}/reorder-email`, body).then((r) => r.data),
    // Attachments
    listAttachments: (id) => client.get(`/api/v1/parts/${id}/attachments`).then((r) => r.data),
    uploadAttachment: (id, file, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        return client.post(`/api/v1/parts/${id}/attachments`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => { if (onProgress && e.total)
                onProgress(Math.round((e.loaded / e.total) * 100)); },
        }).then((r) => r.data);
    },
    viewAttachment: (id, fileId) => client.get(`/api/v1/parts/${id}/attachments/${fileId}/view`, { responseType: 'blob' }).then((r) => r),
    deleteAttachment: (id, fileId) => client.delete(`/api/v1/parts/${id}/attachments/${fileId}`).then((r) => r.data),
});
//# sourceMappingURL=parts.js.map